import { SupportingActivityItemModel } from '../../api/models/rndApplication';
import { VisibilityFunctions } from '../types';

export const showExcluded = (values: SupportingActivityItemModel) =>
    (values.applicationHasIncludedExcludedActivities !== undefined && values.applicationHasIncludedExcludedActivities === 'Yes');

const ArrayHasEntry = (value: any | undefined | null) => value !== undefined && value.length > 0;

export const showOtherOrganisationRadio = (values: SupportingActivityItemModel) => {
    return (ArrayHasEntry(values.crcItems) || ArrayHasEntry(values.levyCollectingRspItems) || ArrayHasEntry(values.rspNonLevyItems));
};

const activitiesPerformedBy123 = (values: SupportingActivityItemModel) => {
    return ['OnlyTheRnDCompany', 'RnDCompanyAndOthers', 'EitherASubsidiary'].includes(values.activityPerformedBy!);
};

const activityConductedBySubsidiary = (values: SupportingActivityItemModel) => {
    return ['Subsidiary'].includes(values.activityConductedBy!);
};

const otherOrganisation134 = (values: SupportingActivityItemModel) => {
    return values.otherOrganisation === 'YesRSP' || values.otherOrganisation === 'YesCRC' || values.otherOrganisation === 'No';
};

export const otherOrganisation123 = (values: SupportingActivityItemModel) => {
    return values.otherOrganisation === 'YesRSP' || values.otherOrganisation === 'YesRSPLevy' || values.otherOrganisation === 'YesCRC';
};

export const activityPerformedBy234 = (values: SupportingActivityItemModel) => {
    return values.activityPerformedBy === 'RnDCompanyAndOthers' || values.activityPerformedBy === 'EitherASubsidiary' || values.activityPerformedBy === 'OnlyOthers';
};

const isSupportCoreActivity = (values: SupportingActivityItemModel) => {
    return values.supportCoreActivity !== undefined && values.supportCoreActivity === 'Yes';
};

const isHeadMecGroup = (values: SupportingActivityItemModel) => {
    return values.organisationMecType !== undefined && values.organisationMecType === 'HeadMecGroup';
};

export const showNoQuestions = (values: SupportingActivityItemModel) => values.otherOrganisation === 'No';

export const showActivityRelations = () => true;

const arrayItemVisible = (arrayName: string, fieldName: string, index: number, values: SupportingActivityItemModel) => {
    const { activityRelations } = values;
    if (arrayName === 'activityRelations' && activityRelations !== null && activityRelations.length > index) {
        return true;
    }

    return true;
};

export const supportingActivities: VisibilityFunctions<SupportingActivityItemModel> = {
    otherOrganisation: values => showOtherOrganisationRadio(values),
    supportForCoreActivities: values => (otherOrganisation134(values)),
    activityPerformedBy: values => (otherOrganisation134(values)),
    nameRNDEntityPerformingSupportingActivity: values => otherOrganisation134(values) && activityPerformedBy234(values),
    isEntityWhoWillConductSupportingConnected: values => otherOrganisation134(values) && activityPerformedBy234(values),
    isSupportingActivityConductedUnderAgreementOutsideAus: values => otherOrganisation134(values) && activityPerformedBy234(values),
    activityConductedBy: values => isHeadMecGroup(values) && otherOrganisation134(values) && activitiesPerformedBy123(values),
    subsidiaryConductingActivity: values => isHeadMecGroup(values)
        && otherOrganisation134(values) && activityConductedBySubsidiary(values) && activitiesPerformedBy123(values),
    otherOrganisationName: values => otherOrganisation123(values),
    briefDescription: values => otherOrganisation123(values),
    totalExpenditure: values => otherOrganisation134(values),
    excluded: values => (otherOrganisation134(values) && showExcluded(values)),
    relatedGoodsAndServices: values => otherOrganisation134(values),
    supportCoreActivity: values => otherOrganisation134(values),
    explainWhyHowSupportingActivityUndertaken: values => (otherOrganisation134(values) && isSupportCoreActivity(values)),
    evidenceAvailable: values => otherOrganisation134(values),
    activityRelations: showActivityRelations,
    arrayItemVisible,
};
